import { create } from "zustand";

import type { AgentChatResponse } from "@/api/types";

export interface AgentTranscriptEntry {
  id: string;
  role: "user" | "assistant";
  content: string;
  createdAt: string;
  sessionId?: string;
}

interface AgentState {
  panelOpen: boolean;
  activeSessionId: string | null;
  transcript: AgentTranscriptEntry[];
  lastResponse: AgentChatResponse | null;
  openPanel: () => void;
  closePanel: () => void;
  togglePanel: () => void;
  setActiveSessionId: (sessionId: string | null) => void;
  addTranscriptEntry: (entry: AgentTranscriptEntry) => void;
  setLastResponse: (response: AgentChatResponse | null) => void;
  clearConversation: () => void;
}

export const useAgentStore = create<AgentState>((set) => ({
  panelOpen: false,
  activeSessionId: null,
  transcript: [],
  lastResponse: null,
  openPanel: () => set({ panelOpen: true }),
  closePanel: () => set({ panelOpen: false }),
  togglePanel: () => set((state) => ({ panelOpen: !state.panelOpen })),
  setActiveSessionId: (activeSessionId) => set({ activeSessionId }),
  addTranscriptEntry: (entry) =>
    set((state) => ({
      transcript: [...state.transcript, entry],
    })),
  setLastResponse: (lastResponse) => set({ lastResponse }),
  clearConversation: () =>
    set({
      activeSessionId: null,
      transcript: [],
      lastResponse: null,
    }),
}));
